/**
 * Labels for lookup values (skills, interests and their categories, event
 * types, cancellation reasons). Czech always comes from the API.
 *
 * Skills, interests and categories have no other language in the database
 * yet, so their translations live in the `lookups` section of the catalogue.
 * They are keyed by code, not by Czech text, so that a copy edit in the
 * database cannot silently drop a translation.
 */

import { findTranslation } from ".";
import { getLang } from "./lang";

export type LookupVariant = "vol" | "org";

const lookupLabel = (key: string, apiLabel: string): string =>
  findTranslation(`lookups.${key}`) ?? apiLabel;

export const skillCategoryLabel = (
  id: string | number,
  apiLabel: string,
): string => lookupLabel(`skillCategories.${id}`, apiLabel);

export const interestCategoryLabel = (
  id: string | number,
  apiLabel: string,
): string => lookupLabel(`interestCategories.${id}`, apiLabel);

export const skillLabel = (
  code: string | number,
  variant: LookupVariant,
  apiLabel: string,
): string => lookupLabel(`skills.${code}.${variant}`, apiLabel);

export const interestLabel = (
  code: string | number,
  variant: LookupVariant,
  apiLabel: string,
): string => lookupLabel(`interests.${code}.${variant}`, apiLabel);

/** For lookups whose English label already comes from the API (event types, cancellation reasons). */
export const pickApiLabel = (czech: string, english?: string): string =>
  getLang() === "en" && english ? english : czech;
